<template>
  <section v-if="lang && lang.expire_link">
    <Title :title-name="title.ExpireLink.titleName" :title-link="title.ExpireLink.titleLink" />
    <div class="container pt-3">
      <div class="block-item row btn-select" style="margin-top: 10px">
        <router-link class="col-12" :to="{ path: '/nps-page', query: { secret: secret } }">
          <div class="row align-items-center">
            <div class="col-3 col-md-2">
              <i class="sb_mobile sb_message text-right"></i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang.expire_link['SFS_LANG_ROW_2'] }}
            </div>
            <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
          </div>
        </router-link>
      </div>
      <div v-if="serviceP2C && pax && !pax.is_expired_p2c">
        <div v-for="(refreshmentItem, index) in serviceP2C.list_refreshment" :key="index" class="block-item row btn-select">
          <router-link
            v-if="refreshmentItem.status != 2"
            class="col-12"
            :to="{ path: '/photo-pay', query: { secret: secret, refreshmentId: refreshmentItem.id } }"
          >
            <div class="row align-items-center">
              <div class="col-3 col-md-2">
                <i class="sb_mobile sb_refreshment text-right"></i>
              </div>
              <div class="item-title col-8 col-md-9">
                {{ lang.expire_link['SFS_LANG_ROW_3'] }}
              </div>
              <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="serviceMC && pax && !pax.is_expired_mc && MonetaryService">
        <div v-for="(monetary, k) in listMonetaryArray" :key="k" v-if="monetary.status != 2" class="block-item row btn-select mt-1">
          <router-link
            class="col-12"
            :to="{ name: 'MonetaryCompensationService', query: { secret: secret, monetary_id: monetary.id, order_id: getMcOrdersProperty(monetary, 'id') } }"
          >
            <div class="row align-items-center">
              <div class="col-3 col-md-2">
                <span class="fa-stack fa-2x icon-monetary">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fa-stack-1x fa-inverse fas fa-hand-holding-usd"></i>
                </span>
              </div>
              <div class="item-title col-8 col-md-9">
                <div v-if="getMcOrdersProperty(monetary, 'compensation_type') != NULL">
                  <span v-if="getMcOrdersProperty(monetary, 'compensation_option') == 0">
                    <span v-if="getMcOrdersProperty(monetary, 'status') == 3"
                      >{{ lang.expire_link['SFS_LANG_ROW_6'] }} - {{ lang.expire_link['SFS_LANG_ROW_9'] }}</span
                    >
                    <span v-else>{{ lang.expire_link['SFS_LANG_ROW_5'] }}N</span>
                  </span>
                  <span v-else>
                    <span v-if="getMcOrdersProperty(monetary, 'status') == 0 && monetary.orders.length == 1">{{
                      lang.expire_link['SFS_LANG_ROW_5']
                    }}</span>
                    <span
                      v-if="
                        getMcOrdersProperty(monetary, 'compensation_type') == 1 &&
                        (getMcOrdersProperty(monetary, 'status') == 1 ||
                        getMcOrdersProperty(monetary, 'status') == 2 ||
                        (getMcOrdersProperty(monetary, 'status') == 0 && monetary.orders.length > 1))
                      "
                    >
                      {{ lang.expire_link['SFS_LANG_ROW_7'] }} {{ k + 1 }}
                    </span>
                    <span
                      v-if="
                        getMcOrdersProperty(monetary, 'compensation_type') == 3 &&
                        (getMcOrdersProperty(monetary, 'status') == 1 ||
                        getMcOrdersProperty(monetary, 'status') == 2 ||
                        (getMcOrdersProperty(monetary, 'status') == 0 && monetary.orders.length > 1))
                      "
                    >
                      {{ lang.expire_link['SFS_LANG_ROW_8'] }} {{ k + 1 }}
                    </span>
                    <span v-if="getMcOrdersProperty(monetary, 'compensation_type') == 1 && getMcOrdersProperty(monetary, 'status') == 3">
                      {{ lang.expire_link['SFS_LANG_ROW_7'] }} {{ k + 1 }} - {{ lang.expire_link['SFS_LANG_ROW_9'] }}
                    </span>
                    <span v-if="getMcOrdersProperty(monetary, 'compensation_type') == 3 && getMcOrdersProperty(monetary, 'status') == 3">
                      {{ lang.expire_link['SFS_LANG_ROW_8'] }} {{ k + 1 }} - {{ lang.expire_link['SFS_LANG_ROW_9'] }}
                    </span>
                  </span>
                </div>
                <div v-else>
                  {{ lang.expire_link['SFS_LANG_ROW_5'] }}
                </div>
              </div>
              <div class="col-1 bullet_right"><i class="fas fa-angle-double-right fa-1x"></i></div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'

export default {
  name: 'ExpireLink',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      serviceP2C: {},
      serviceMC: {}
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      MonetaryService: 'Home/monetaryService'
    }),
    listMonetaryArray() {
      const listMonetaryArray = this.MonetaryService.list_monetary.reduce((acc, obj) => ({ ...acc, [obj.voucher_code]: obj }), {})
      return _.toArray(listMonetaryArray)
    },
  },
  watch: {
    airline: function () {
      this.initData()
    },
    pax: function () {
      this.initData()
    },
    Services: function () {
      this.initData()
    }
  },
  created() {
    this.$store.dispatch('Home/getServices')
  },
  methods: {
    initData() {
      if (!_.isEmpty(this.airline) && !_.isEmpty(this.pax) && !_.isEmpty(this.Services)) {
        this.serviceP2C = _.find(this.Services, { service_id: 2 })
        this.serviceMC = _.find(this.Services, { service_id: 21 })
        let secret = this.$route.query.secret
        if (this.airline.meal_enabled != '2' || !this.pax.is_expired) {
          this.$router.push({ path: '/home', query: { secret: secret } })
        } else if (_.isEmpty(this.serviceP2C) && _.isEmpty(this.serviceMC)) {
          this.$router.push({ path: '/nps-page', query: { secret: secret } })
        } else if (!(this.serviceP2C && !this.pax.is_expired_p2c) && !(this.serviceMC && !this.pax.is_expired_mc)) {
          this.$router.push({ path: '/nps-page', query: { secret: secret } })
        }
      }
    },
    getMcOrdersProperty(monetary, property) {
      if (monetary && monetary.orders && monetary.orders[0]) {
        return monetary.orders[0][property] || null;
      }
      return null;
    }
  }
}
</script>
